import { breakpoints } from '@oaknorth/component-core-v2';

import { MediaType } from './types';

export const MEDIA_TYPE_TO_BP: Record<MediaType, string> = {
  [MediaType.SMALL_SCREEN]: breakpoints.base,
  [MediaType.MOBILE]: breakpoints.sm,
  [MediaType.TABLET]: breakpoints.md,
  [MediaType.LAPTOP]: breakpoints.lg,
  [MediaType.DESKTOP]: breakpoints.xl,
  [MediaType.LARGE_SCREEN]: breakpoints['2xl'],
};
